import { styled } from '@mui/material/styles'
import { Grid, Box } from '@mui/material'

export const OuterWrapper = styled(Grid)(`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vw;
`)

export const Wrapper = styled(Grid)(`
    padding:25px;
    overflow:auto;
    height:calc(100vh - 70px);
    & .accordionWrapper {
        margin-bottom:40px;
    }
`)

export const ButtonWrapper = styled(Box)(`
    display: flex;
    justify-content: end;
    align-items: center;
    width:100%;

    & button { padding:0; background:transparent !important; }
    & span { margin:0 10px; }

    & .expanded, & .collapsed {font-weight:bold;}
`)
